import { ref } from '@vue/composition-api'
import moment from 'moment'
import store from '@/store'
import { GET_SALES_ANALYTICS_SELECTIONS_LIST } from '@/store/modules/sales-analytics.module'
import { RESET_SALES_ANALYTICS_NAV_INDICATOR } from '@/store/modules/notification.module'
import { apiToastError } from '@/@core/utils/toast'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import { routePaths } from '@/router/routes/apps'

export function useSalesAnalytics() {
  const selectionList = ref([])
  const totalSelections = ref(0)
  const sharedDate = ref(null)
  const pageNumber = ref(1)
  const perPage = ref(10)
  const isLoading = ref(false)

  function getSharedDateWithFormat() {
    const datePayloadFormat = 'YYYY-MM'
    if (sharedDate.value) {
      const parsedDate = moment(sharedDate.value, 'MMM YYYY', true)
      return parsedDate.format(datePayloadFormat)
    }
    return moment().format(datePayloadFormat)
  }

  function loadSelections(isLiveUpdate = false) {
    isLoading.value = !isLiveUpdate
    const params = {
      page: pageNumber.value - 1,
      limit: perPage.value,
      sharedDate: getSharedDateWithFormat(),
    }
    store.dispatch(GET_SALES_ANALYTICS_SELECTIONS_LIST, params)
      .then(res => {
        const resData = res.data.data
        selectionList.value = resData.salesInsights
        totalSelections.value = resData.count
        isLoading.value = false
      })
      .catch(err => {
        isLoading.value = false
        apiToastError(err)
      })
  }

  function onFilterByDate(date) {
    pageNumber.value = 1
    sharedDate.value = date
    loadSelections(true)
  }

  function onApplyPagination() {
    analytics.track(constants.TRACKS.ACTIONS.BRAND_APPLIES_PAGINATION_IN_SALES_INSIGHTS_PAGE, { pageNumber: pageNumber.value })
    loadSelections(true)
  }

  function routeToShareSelection(router) {
    router.push({ name: routePaths.selection })
    analytics.track(constants.TRACKS.ACTIONS.BRNAD_CLICKS_CLICK_HERE_HYPERLINK_IN_SALES_INSIGHTS_PAGE)
  }

  function initSalesAnalytics() {
    analytics.track(constants.TRACKS.ACTIONS.BRAND_OPENS_SALES_INSIGHTS_TAB)
    loadSelections()
    store.commit(RESET_SALES_ANALYTICS_NAV_INDICATOR)
  }

  function getDateAndTime(date = '') {
    return date ? moment(date).format('DD/MM/YYYY HH:mmA') : ''
  }

  function onClickSelection(selection, router) {
    router.push({ name: 'selection-products', params: { wishlistId: selection.selectionId } })
    analytics.track(constants.TRACKS.ACTIONS.BRAND_CLICKS_A_SELECTION_IN_SALES_INSIGHTS_PAGE, { selection })
  }

  return {
    selectionList,
    totalSelections,
    sharedDate,
    pageNumber,
    perPage,
    isLoading,
    getSharedDateWithFormat,
    loadSelections,
    onFilterByDate,
    onApplyPagination,
    routeToShareSelection,
    initSalesAnalytics,
    getDateAndTime,
    onClickSelection,
  }
}
